import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "..";
import { UIFlightData, UILuggageType } from "@flights/types";
import {
  getAvailabilityAsAncillary,
  isInfantWithNoBaggageAllowance
} from "../../../components/elements/FlightDetailsInner/components/FlightDetailsInfo/Items/DetailedBaggageInfo/useDetailedBaggageInfo.controller";

const utils = createTrackingUtils({
  name: "flights_web_fd_baggage_transparency",
  stages: {
    users_on_fd: 1,
    main: 2,
    direct: 3,
    meta: 4,
    desktop: 5,
    mobile: 6,
    infants_with_no_baggage: 7
  },
  defaultStage: 1,
  goals: {
    close_fd: 1
  }
});

export const useTrackBaggageTransparencyFD = (flight: UIFlightData, canTrack: boolean) => {
  const { isDirect, isMeta, isDesktop, isMobile } = useProfiler();

  if (!canTrack) {
    return;
  }

  const hasNotIncludedBaggage =
    flight.includedProducts?.segments.some((segment) =>
      ["PERSONAL_ITEM", "HAND", "CHECKED_IN"].some(
        (l) =>
          !segment.find((s) => s.luggageType === l) &&
          getAvailabilityAsAncillary(flight, l as UILuggageType) === "NOT_AVAILABLE"
      )
    ) || false;

  if (hasNotIncludedBaggage) {
    utils.stages.main();
    isDirect() && utils.stages.direct();
    isMeta() && utils.stages.meta();
    isDesktop() && utils.stages.desktop();
    isMobile() && utils.stages.mobile();
    isInfantWithNoBaggageAllowance(flight) && utils.stages.infants_with_no_baggage();
  }
};

export default utils;
